class SelectCategoryRequest {
    SelectCategoryURL(){
        return process.env.REACT_APP_BASEURL+"SelectCategory"
    }
}
export const {SelectCategoryURL}=new SelectCategoryRequest();


